import Vue from "vue";
import Vuex from "vuex";
import { AuthStore } from "./modules/auth";
import { AnalysisStore } from "./modules/analysis";
import { UploadStore } from "./modules/upload";
import { RulesetStore } from "./modules/ruleset";
import { UserStore } from "./modules/user";
import { TeamStore } from "./modules/team";
import { InfoStore } from "./modules/info";
import { FindingStore } from "./modules/findings";
import { DashboardStore } from "./modules/dashboard";
import { NotificationStore } from "./modules/notification";
import { EnumerationStore } from "./modules/enumeration";
import { ContactStore } from "./modules/contact";
import { SettingStore } from "./modules/setting";
import { IdentityStore } from "./modules/identity";
import { ReportFindingStore } from "./modules/report";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth: AuthStore,
    analysis: AnalysisStore,
    upload: UploadStore,
    ruleset: RulesetStore,
    user: UserStore,
    team: TeamStore,
    info: InfoStore,
    findings: FindingStore,
    dashboard: DashboardStore,
    notification: NotificationStore,
    enumeration: EnumerationStore,
    contact: ContactStore,
    setting: SettingStore,
    identity: IdentityStore,
    report: ReportFindingStore
  },
  state: {},
  mutations: {},
  actions: {}
});
